import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { organizationsKeys } from './organizationsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.search>>;

export const createFetchOrganizationSearchQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, search }], signal }: TParams) =>
    call(() => cancelOnSignal(OrganizationsService.search({ oid: organizationId, search }), signal));
